import { useState } from 'react';
import { formatDateMoment, TranslateText } from '@/helpers/utils/siteUtils';
import { DATE_FORMAT, DEFAULT_SITE_LANG } from '../../../../../../constants/constant';
import PaymentGaurdianDetailsModal from '../../../modals/customerDetailAction/paymentGuardianDetails';
import PaymentGuardianLearnMoreModal from '../../../modals/orderDetails/paymentGuardian';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';
import { Table, TableColumnConfig } from '../../../ui/customTable/Table';
import { PAYMENT_GUARDIAN_HEADERS, PAYMENT_GUARDIAN_KEYS } from '../../constants';
import { PageTexts } from '../../i18n';
import { PaymentGuardianData } from '../../types';

const PaymentGuardian = ({
  creditProtectionInfo,
  paymentGuardianData,
  isEligible,
  onlyShowModal = false,
}: {
  creditProtectionInfo: any;
  paymentGuardianData: PaymentGuardianData;
  isEligible?: boolean;
  onlyShowModal?: boolean;
}) => {
  const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal1, setShowModal1] = useState(onlyShowModal);
  const [data, setData] = useState([creditProtectionInfo ?? {}]);
  const paymentGaurdianCols: TableColumnConfig<any>[] = [
    {
      key: PAYMENT_GUARDIAN_KEYS.PAYMENT_GUARDIAN_ELIGIBLE,
      header: PAYMENT_GUARDIAN_HEADERS.PAYMENT_GUARDIAN_ELIGIBLE,
      render: (data) => <div>{data ? 'Eligible' : 'Not Eligible'}</div>,
    },
    {
      key: PAYMENT_GUARDIAN_KEYS.STATUS,
      header: PAYMENT_GUARDIAN_HEADERS.STATUS,
    },
    {
      key: PAYMENT_GUARDIAN_KEYS.ENROLLMENT_DATE,
      header: PAYMENT_GUARDIAN_HEADERS.ENROLLMENT_DATE,
      render: (data) => <>{isEligible ? formatDateMoment(data, DATE_FORMAT) : 'N/A'}</>,
    },
    {
      key: PAYMENT_GUARDIAN_KEYS.CANCELLATION_DATE,
      header: PAYMENT_GUARDIAN_HEADERS.CANCELLATION_DATE,
      render: (data) => <>{isEligible ? formatDateMoment(data, DATE_FORMAT) : 'N/A'}</>,
    },
  ];

  const renderModals = () => {
    return (
      <>
        <PaymentGaurdianDetailsModal
          paymentGuardianData={paymentGuardianData}
          Texts={Texts}
          open={showModal2}
          setOpen={setShowModal2}
        />
        <PaymentGuardianLearnMoreModal
          paymentGuardianData={paymentGuardianData}
          Texts={Texts}
          setData={setData}
          open={showModal1}
          setOpen={setShowModal1}
        />
      </>
    );
  };

  if (onlyShowModal) {
    return renderModals();
  }

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full rounded-md border border-foggyGray px-5 py-1 shadow-lg"
      defaultValue="item-1"
    >
      <AccordionItem value="item-1" className="border-none">
        <AccordionTrigger className="text-lg font-bold hover:no-underline">{Texts.paymentGaurdian}</AccordionTrigger>

        <AccordionContent className=" text-base">
          {isEligible && (
            <div className="grid justify-items-end">
              {renderModals()}
              <button
                onClick={() => {
                  if (data?.[0]?.isEnrolled) {
                    setShowModal2(true);
                    setShowModal1(false);
                  } else {
                    setShowModal2(false);
                    setShowModal1(true);
                  }
                }}
                className="mb-4 h-[30px] rounded-md border-[1px] border-foggyGray px-4 py-1.5 text-xs font-medium"
              >
                {Texts.managePaymentGuardian}
              </button>
            </div>
          )}
          <Table data={data} columns={paymentGaurdianCols} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default PaymentGuardian;
